import { render } from "./SiteHeaderNav.vue?vue&type=template&id=1bdc00c2"
import script from "./SiteHeaderNav.vue?vue&type=script&lang=js"
export * from "./SiteHeaderNav.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__